













































































































































































import { Component, Watch, Mixins } from 'vue-property-decorator'
import moment from 'moment-timezone'
import DateRangePicker from 'buefy-daterange-picker'
// Models
import UserModel from '@/_models/UserModel'
import BeaconModel from '@/_models/BeaconModel'
import StampRallyApiResponse from '@/_models/StampRallyApiResponse'
import StampRallyModel from '@/_models/StampRallyModel'
// Common
import NotFound from '@/components/common/NotFound.vue'
// Shared
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import TablePagination from '@/components/shared/TablePagination.vue'
// Mixins
import DateRangeMixin from '@/components/mixins/DateRangeMixin.vue'
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'
import { Filter } from '@/_utils/filter'
import { Constant } from '@/_services/constant'
@Component({
  components: {
    DateRangePicker,
    FilterDropdown,
    NotFound,
    TablePagination,
  },
  computed: {},
})
export default class WorkRecorderChart extends Mixins(
  DateRangeMixin,
  TableSortMixin
) {
  filterUtilTableSort: any = new Filter('filter_stamp_rally_table_sort')
  // data
  filterUtilPage: any = new Filter('filter_stamp_rally_page')
  numofPage: number = 1
  pageFilters: any = {
    currentPage: 1,
    perPage: 20,
    selectedFilter: 'san_id',
    searchQuery: '',
  }
  filedNameLUT: any = {
    san_id: 'label.san_id',
    name: 'label.username',
  }
  defaultTime: any = {
    start: moment().set({ hour: 0, minute: 0 }).toDate(),
    end: moment().set({ hour: 24, minute: 0 }).toDate(),
  }
  selectedUser: UserModel = new UserModel()
  get isLoading(): boolean {
    return this.$store.state.users.loading || this.$store.state.analysis.loading
  }
  get beacons(): BeaconModel[] {
    return this.$store.state.beacons.all.items
  }
  get filteredUser(): UserModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.users) {
      return []
    }
    return this.users.filter(
      (item: UserModel): boolean =>
        !!item.san_id &&
        String(item[targetField]).toLowerCase().includes(this.pageSearchQuery)
    )
  }
  get users(): UserModel[] {
    return this.$store.state.users.all.items_raw
  }
  get pageSearchQuery(): string {
    return this.pageFilters.searchQuery.toLowerCase()
  }
  get stampRallies(): StampRallyApiResponse[] {
    return this.$store.state.analysis.all.stamp_rallies
  }
  get startDate() {
    return this.defaultTime.start
  }
  get endDate() {
    return this.defaultTime.end
  }
  get totalDataScore() {
    return this.filteredData.reduce((a, b) => a + (b.score || 0), 0)
  }
  get filteredData(): StampRallyModel[] {
    let results: StampRallyModel[] = []
    this.stampRallies
      .filter((item) => item.location_name && item.floor_name)
      .forEach((item: StampRallyApiResponse) => {
        const userInfo = this.users.find((user) => user.san_id === item.san_id)
        const location = `${item.floor_name}: ${item.location_name}`
        const arrivedAt = moment(item.arrived_at).format('YYYY-MM-DD HH:mm')

        const dataScore: StampRallyModel = {
          san_id: userInfo ? userInfo.san_id : '-',
          u_name: userInfo ? userInfo.name : '-',
          location,
          arrived_at: arrivedAt,
          score: parseInt(item.location_name.split('_')[0], 10) || 0, // E.g 5_Room A
        }
        results = this.appendArrivedAt(results, dataScore)
      })
    // Set numof page
    this.numofPage = Math.ceil(results.length / this.pageFilters.perPage)

    return results.filter((item) => {
      const arrivedAt = this.formatToMinutes(new Date(item.arrived_at))
      const startMinutes = this.formatToMinutes(this.startDate)
      let endMinutes = this.formatToMinutes(this.endDate)
      endMinutes = endMinutes === 0 ? 24 * 60 : endMinutes
      return startMinutes <= arrivedAt && arrivedAt <= endMinutes
    })
  }
  @Watch('selectedUser')
  @Watch('dateRange')
  dateRangeChanged(): void {
    this.$nextTick(() => {
      if (!this.pageFilters.searchQuery) {
        return
      }
      this.saveDaterange()
      this.filterUtilPage.save(this.pageFilters)
      this.getAllStampRally()
    })
  }
  @Watch('pageFilters.selectedFilter')
  onFilterChange() {
    this.pageFilters.searchQuery = ''
  }
  appendArrivedAt(list: StampRallyModel[], newItem) {
    const foundIndex = list.findIndex(
      (item) => item.location === newItem.location
    )
    if (foundIndex > -1) {
      list[foundIndex].arrived_at = list[foundIndex].arrived_at.concat(
        newItem.arrived_at
      )
    } else {
      list.push(newItem)
    }

    return list
  }
  getAllStampRally() {
    if (
      this.$store.state.all_locations.loading ||
      !this.selectedUser ||
      !this.selectedUser?.san_id
    ) {
      return
    }
    this.$store.dispatch('analysis/getAllStampRally', {
      date_from: moment(this.dateRange.startDate).format(this.queryDateFormat),
      date_to: moment(this.dateRange.endDate).format(this.queryDateFormat),
      san_id: this.selectedUser?.san_id,
    })
  }
  setFirstLoadSelectedUser() {
    this.selectedUser =
      this.users.find((user) => user.san_id === this.pageFilters.searchQuery) ||
      new UserModel()
  }
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }
  formatToMinutes(date: Date) {
    return moment(date).minutes() + moment(date).hours() * 60
  }
  // After page created
  async created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.dateRange = this.filterUtilDateRange.get(this.dateRange)
    await this.$store.dispatch('users/getUsersRaw')
    await this.$store.dispatch('beacons/getAll', {
      beacon_type: Constant.BEACON_TYPE_STATIC,
    })
    this.setFirstLoadSelectedUser()
  }
}
